import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
  type OnInit,
} from '@angular/core';

@Component({
  selector: 'market-count-down',
  standalone: true,
  imports: [],
  templateUrl: './count-down.component.html',
  styleUrl: './count-down.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountDownComponent implements OnInit {
  @Input() endDate = '';
  countdown = signal('');
  ngOnInit(): void {
    this.startCountdown();
  }

  startCountdown() {
    const endDate = new Date(this.endDate).getTime();
    this.calculate(endDate);
    const interval = setInterval(() => {
      this.calculate(endDate, interval);
    }, 1000);
  }

  calculate(endDate: number, interval?: NodeJS.Timeout) {
    const now = new Date().getTime();
    const distance = endDate - now;

    if (distance < 0) {
      clearInterval(interval);
      this.countdown.set('EXPIRED');
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    let time = '';

    if (days) {
      time += days + 'd ';
    }

    if (hours) {
      time += hours + 'h ';
    }

    if (minutes) {
      time += minutes + 'm ';
    }

    if (seconds) {
      time += seconds + 's ';
    }

    this.countdown.set(time);
  }
}
